define([], ()=> {
    return ['$q', 'JsonRPCService', function ($q, JsonRPCService) {
        return {
            autofillBasedOnAdddress(callGroups, address) {
                const deferred = $q.defer();
                JsonRPCService.send('addressLookup', 'lookup', 'lookupAddressUsingString', [address], callGroups).then(
                    (addressResult) => deferred.resolve(addressResult),
                    (error, status, headers) => deferred.reject([error, status, headers])
                );
                return deferred.promise;
            },

            autofillBasedOnPostalCode(callGroups, address) {
                const deferred = $q.defer();
                JsonRPCService.send('addressLookup', 'lookup', 'lookupAddressUsingObject', [address], callGroups).then(
                    (addressResult) => deferred.resolve(addressResult),
                    (error, status, headers) => deferred.reject([error, status, headers])
                );
                return deferred.promise;
            }
        };
    }];
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/policyjob/services/AddressLookupService.js
 **/